<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text"> Информационные бюллетени </span>
        <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false"
          color="var(--app-dark-blue-1)">mdi-information</v-icon>
      </div>
      <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
        <v-card min-width="300px" min-height="100px">
          <div class="menu-container">
            <div class="menu-container-text">
              Раздел мобильного приложения, который отображает список файлов по
              годам.
            </div>
            <div class="menu-container-title">Кнопка обновления списка</div>
            <div class="menu-container-text">
              Список email, которые подписаны на рассылку через сайт,
              рекомендуемое обновление - 1 раз в 7 дней.
            </div>
            <div class="menu-container-title">
              Иконка
              <v-icon small color="#929292"> mdi-bell-outline </v-icon>
            </div>
            <div class="menu-container-text">
              При нажатии откроется окно для отправки Push-уведомление всем
              пользователям, которые подписанны на рассылку.
            </div>
            <div class="menu-container-title">
              Иконка
              <v-icon small color="#929292"> mdi-cached </v-icon>
            </div>
            <div class="menu-container-text">
              При нажатии откроется окно для отправки повторного
              Push-уведомление всем пользователям, которые подписанны на
              рассылку.
            </div>
          </div>
        </v-card>
      </v-menu>
      <v-spacer></v-spacer>
      <v-btn @click="downloadTable" style="width: auto !important" outlined color="var(--app-dark-blue-1)"
        class="button-accept-outlined mr-10">
        <template v-if="!dateTable"> Загрузить список Email-рассылки </template>
        <template v-else>
          Обновить список Email-рассылки ({{
            dateTable | moment("DD.MM.YYYY")
          }})</template>
      </v-btn>
      <input style="display: none" type="file" ref="downloadInput" accept=".xlsx, .xls, .csv" @change="previewFiles" />
      <v-btn @click="openDialog" style="width: auto !important" class="button-accept">
        + Добавить бюллетень
      </v-btn>
    </div>
    <div>
      <div class="table-container">
        <v-data-table :headers="headers" :items="items" class="elevation-0 main-table" :disable-pagination="true"
          :hide-default-footer="true" fixed-header>
          <template v-slot:[`item.fileName`]="{ item }">
            <div v-if="item.file">
              {{ item.file.name }}
            </div>
          </template>
          <template v-slot:[`item.file`]="{ item }">
            <div v-if="item.file">
              <a target="_blank" :href="item.file.file">PDF-файл</a>
            </div>
          </template>
          <template v-slot:[`item.dateCreated`]="{ item }">
            {{ item.dateCreated | moment("DD.MM.YYYY") }}
          </template>
          <template v-slot:[`item.push`]="{ item }">
            <div v-if="!item.wasPushSendingRequested" @click="openDialogPush(item)">
              <v-icon>mdi-bell-outline</v-icon>
            </div>
            <div v-else @click="openDialogPush(item)">
              <v-icon>mdi-cached</v-icon>
            </div>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <div @click="openDialog(item)">
              <v-icon>mdi-pencil-outline</v-icon>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
    <v-divider></v-divider>

    <v-dialog width="570px" height="auto" persistent v-model="dialog">
      <v-card width="570px" height="auto" class="rounded-0">
        <v-form ref="formFirst">
          <v-card-title class="dialog-title">
            <span v-if="selectedItem && selectedItem.id" class="title">Редактировать бюллетень</span>
            <span v-else class="title">Добавление бюллетени</span>
            <v-icon @click="closeDialog">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <v-select :items="listItems" outlined :rules="rules" v-model="selectedItem.year" label="Год"></v-select>
            <v-text-field label="Название файла" required type="text" outlined :rules="rules"
              v-model="selectedItem.fileName"></v-text-field>
            <v-file-input outlined show-size v-model="selectedItem.file" label="Прикрепите файл pdf" :rules="[
              (value) =>
                (value && value.size < 104857600) ||
                'Размер pdf не больше 100 мб',
            ]" hint="Максимальный размер pdf 100 Мб" persistent-hint accept="application/pdf,application/vnd.ms-excel">
            </v-file-input>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn style="width: 120px !important" @click="saveItem" class="button-accept">
              Сохранить
            </v-btn>
            <v-btn v-if="selectedItem && selectedItem.id" @click="dialogDelete = true" style="width: 120px !important"
              class="button-accept-outlined" outlined color="var(--app-red-1)">
              Удалить
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
      <v-card>
        <v-card-title class="dialog-title">
          <span class="title">Точно хотите удалить бюллетень?</span>
          <v-icon @click="dialogDelete = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-actions class="dialog-buttons">
          <v-btn @click="dialogDelete = false" style="width: 120px" outlined color="var(--app-green-1)">
            Нет
          </v-btn>
          <v-btn @click="deleteItem" style="width: 120px" outlined color="var(--app-red-1)">
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="500px" height="auto" persistent v-model="dialogPush">
      <v-card width="500px" height="auto" class="rounded-0">
        <v-form lazy-validation ref="push">
          <v-card-title class="dialog-title">
            <span class="title">Отправить PUSH</span>
            <v-icon @click="closeDialogPush">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <v-text-field label="Заголовок" required type="text" outlined :rules="rules"
              v-model="push.title"></v-text-field>
            <v-text-field label="Сообщение" required type="text" outlined :rules="rules"
              v-model="push.description"></v-text-field>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="sendPush" class="button-accept"> Отправить </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>


export default {
  data: () => ({
    dialog: false,
    dialogDelete: false,
    dialogPush: false,
    showInfo: false,
    x: null,
    y: null,
    items: [],
    listItems: [],
    rules: [(value) => !!value || "Обязательно к заполнению"],
    push: {},
    selectedItem: {
      year: 0,
      file: null,
      fileName: "",
    },
    dateTable: null,

    headers: [
      {
        text: "Год",
        sortable: false,
        value: "year",
        align: "left",
      },
      {
        text: "Название файла",
        sortable: false,
        value: "fileName",
        align: "left",
      },
      {
        text: "Файл",
        sortable: false,
        value: "file",
        align: "left",
        width: "200px",
      },
      {
        text: "Дата добавления",
        sortable: false,
        value: "dateCreated",
        align: "left",
        width: "150px",
      },
      {
        text: "",
        sortable: false,
        value: "push",
        align: "right",
        width: "60px",
      },
      {
        text: "",
        sortable: false,
        value: "action",
        align: "right",
        width: "60px",
      },
    ],
  }),
  watch: {},
  methods: {
    downloadTable() {
      this.$refs.downloadInput.click();
    },
    deleteFile() {
      this.selectedItem.file = null;
    },
    createRange() {
      let length = 50;
      const step = new Date().getFullYear() - 30;
      this.listItems = Array.from({ length }, (v, k) => k + step);
    },
    openDialogPush(item) {
      this.push.bulletinId = item.id;
      this.push.title = item.file ? item.file.name : "";
      this.dialogPush = true;
    },
    openDialog(item) {
      this.selectedItem = item ? JSON.parse(JSON.stringify(item)) : {};
      item && item.file ? (this.selectedItem.fileName = item.file.name) : "";
      this.dialog = true;
      if (this.$refs.formFirst) {
        this.$refs.formFirst.resetValidation();
      }
    },
    closeDialogPush() {
      this.dialogPush = false;
      setTimeout(() => {
        this.push = {};
        this.$refs.push.reset();
        this.$refs.push.resetValidation();
      }, 500);
    },
    closeDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.selectedItem = {};
        this.$refs.formFirst.reset();
        this.$refs.formFirst.resetValidation();
      }, 500);
    },
    deleteItem() {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV2 + "/bulletin", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            bulletinId: this.selectedItem.id,
          },
        })
        .then(() => {
          this.dialogDelete = false;
          this.closeDialog();
          this.getItems();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    sendPush() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/bulletin/push/send",
          {
            bulletinId: this.push.bulletinId,
            title: this.push.title,
            description: this.push.description,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.closeDialogPush();
          this.getItems();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    saveItem() {
      if (this.$refs.formFirst.validate()) {
        let formData = new FormData();
        if (this.selectedItem.id) {
          formData.append("bulletinId", this.selectedItem.id);
        }
        formData.append("year", this.selectedItem.year);
        formData.append("fileName", this.selectedItem.fileName);
        if (this.selectedItem.file && this.selectedItem.file.dateCreated) {
          formData.append("file", JSON.stringify(this.selectedItem.file));
        } else {
          formData.append("file", this.selectedItem.file);
        }

        this.$axios
          .post(this.$store.getters.apiAdminPanelV2 + "/bulletin", formData, {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          })
          .then(() => {
            this.selectedItem = {};
            this.dialog = false;
            this.getItems();
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      }
    },
    previewFiles(event) {
      if (event.target.files[0]) {
        let formData = new FormData();
        formData.append("table", event.target.files[0]);
        this.$axios
          .post(
            this.$store.getters.apiAdminPanelV2 + "/bulletin/table/upload",
            formData,
            {
              headers: {
                authorization: this.$store.getters.adminPanelHeaderAuth,
              },
            }
          )
          .then(() => {
            this.$refs.downloadInput.value = null;
            this.getItems();
            this.getTableDate();
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      }
    },
    openInfo(e) {
      e.preventDefault();

      this.x = e.clientX + 10;
      this.y = e.clientY + 10;
      this.showInfo = true;
    },

    getItems() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/bulletin/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.items = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getTableDate() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV2 + "/bulletin/table/upload/date",

          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.dateTable = res.data.dateCreated;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
  created() {
    this.createRange();
    this.getTableDate();
    this.getItems();
  },
};
</script>
<style lang="scss" scoped>
.table-container {
  height: calc(100vh - 190px);

  .main-table {
    height: calc(100vh - 190px) !important;
    min-height: calc(100vh - 190px) !important;
    max-height: calc(100vh - 190px) !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
</style>